const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
export default {
  randomUUID
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/uuid/dist/esm-browser/native.js
// module id = null
// module chunks = 